<template>
  <div class="mb-2">
    <h1>
      {{ $t("functionControlMaintenanceForProduct") }}
      <strong>#{{ productID }}</strong>
    </h1>
    <hr />
    <b-form v-if="product.productID" @submit.prevent="submit">
      <b-row class="no-mar">
        <b-col lg="6">
          <function-control-product
            v-model="product"
            class="mb-2"
            :productid="product.productID"
            :itemdescription="product.description"
            :productright="product.rfc"
            :productleft="product.lfc"
            :options="options"
            :allow-repair="true"
          />
        </b-col>
      </b-row>

      <hr />
      <b-button
        v-if="product.productID"
        type="submit"
        class="btn btn-primary"
        >{{ $t("submit3") }}</b-button
      >
    </b-form>
    <div v-if="!product.productID">
      <p>
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
import FunctionControlProduct from "./FunctionControlProduct"
import { BForm, BButton, BRow, BCol } from "bootstrap-vue"
import {
  getFunctionControlMaintenanceData,
  getFunctionControlMaintenanceOptions,
  saveFunctionControlMaintenance,
} from "../../services/functionControl"
export default {
  components: {
    FunctionControlProduct,
    BForm,
    BButton,
    BRow,
    BCol,
  },
  data() {
    return {
      product: {},
      data: {},
      options: [],
      message: this.$t("itemNotReadyForMaintenance"),
    }
  },
  computed: {
    urlSearchParams() {
      return new URLSearchParams(window.location.search)
    },
    params() {
      return Object.fromEntries(this.urlSearchParams.entries())
    },
    productID() {
      return this.params?.ProductID
    },
    productCount() {
      return Object.keys(this.functionControlList).length
    },
    customerID() {
      return this.$store.state.customerID
    },
  },
  async created() {
    const customerField = document.getElementsByName("customerid")

    this.$store.commit("setCustomerID", { customerID: customerField[0].value })
    this.product = await getFunctionControlMaintenanceData({
      productID: this.productID,
      customerID: this.customerID,
    })
    this.options = await getFunctionControlMaintenanceOptions({
      productID: this.productID,
    })
  },
  methods: {
    submit: async function () {
      const result = await saveFunctionControlMaintenance({
        productID: this.productID,
        functionControlMaintenance: this.product,
        customerID: this.customerID,
      })

      if (result.message) {
        this.message = result.message
        this.$toasted.show(result.message)
      }

      if (result.success) {
        this.product = {}
      }
    },
  },
}
</script>

<style scoped>
h1 {
  text-transform: capitalize;
  font-size: 1.5625rem;
  margin-top: 0;
}
pre {
  white-space: pre-wrap;
}
pre {
  overflow-x: auto;
}
hr {
  clear: both;
  max-width: 100%;
}
</style>
